<div class="toolbar" role="banner" style="position: fixed;">
  <div style="padding: 0px; height: 42px; width: 42px; border: 1px solid #000; margin-left: 5%; margin-right: 5%;">
    <img src="../../../assets/mtn-logo.png" style="width: 40px; height: 40px" />
  </div>
  <span style="color: #000">MTN FINGER CAPTURE</span>
  <div class="spacer"></div>
</div>

<ng-template [ngIf]="!isLoading">
  <div class="content" role="main">
    <div class="row">

      <!-- <div *ngIf="showCapture" class="col-12 content" style="margin-top: 10px;">
        <div class="row" style="display: flex; justify-content: center; align-items: center;">
          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; height: 12.499%; max-height: 12.499%;">
            <img [src]="leftthumb" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">LEFT THUMB</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; height: 12.499%; max-height: 12.499%;">
            <img [src]="leftindex" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">LEFT INDEX</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; height: 12.499%; max-height: 12.499%;">
            <img [src]="leftmiddle" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">LEFT MIDDLE</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0% !important; margin-bottom: 0% !important;">
            <img [src]="leftring" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">LEFT RING</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="leftlittle" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">LEFT LITTLE</p>
          </div>
        </div>
        <div class="row" style="display: flex; justify-content: center; align-items: center;">
          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="rightthumb" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">RIGHT THUMB</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="rightindex" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">RIGHT INDEX</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="rightmiddle" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">RIGHT MIDDLE</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="rightring" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">RIGHT RING</p>
          </div>

          <div class="col-12"
            style="display: flex; justify-content: center; align-items: center; margin-top: 0px !important; margin-bottom: 0px !important;">
            <img [src]="rightlittle" width="72px" height="150px" style="transform: rotate(90deg)" />
            <p style="margin-left: 5rem;">RIGHT LITTLE</p>
          </div>
        </div>
      </div> -->

      <div class="col-12"
        style="display: flex; position: absolute; bottom: 40px; justify-content: center; align-items: center; position: fixed;">
        <div class="row" style=" align-content: center;">
          <button class="btn btn-block" style="background-color: #ffcb00; color: #fff !important; padding: 10px 35px;"
            (click)="refreshCapture()">Refresh</button>
        </div>
      </div>

    </div>

  </div>
</ng-template>
<ng-template [ngIf]="isLoading">
  <!-- <div class="container"> -->
  <div class="mask">
    <i class="pei pei-spinner"></i>
  </div>
  <!-- </div> -->
</ng-template>